export default __webpack_public_path__ + "static/media/profile-2.e2f12c96.png";